import { render, staticRenderFns } from "./TradingJournal.vue?vue&type=template&id=bc01247a&scoped=true"
import script from "./TradingJournal.vue?vue&type=script&lang=js"
export * from "./TradingJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc01247a",
  null
  
)

export default component.exports